var map = {
	"./AAF.svg": 476,
	"./AAK.svg": 477,
	"./AAU.svg": 478,
	"./Instagram.svg": 479,
	"./Niras.svg": 480,
	"./close.svg": 481,
	"./hamburgermenu.svg": 482,
	"./home.svg": 483,
	"./logo.svg": 484,
	"./logo_brave.svg": 485,
	"./logo_chrome.svg": 486,
	"./logo_edge.svg": 487,
	"./logo_firefox.svg": 488,
	"./logo_opera.svg": 489,
	"./marker.svg": 490,
	"./pdf.svg": 491,
	"./reporting.svg": 492,
	"./signup.svg": 493
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 475;